(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const body = document.body;
  const drawer = $('[data-cart-drawer]');
  const menu = $('[data-mobile-menu]');
  const backdrop = $('[data-drawer-backdrop]');
  const toast = $('[data-toast]');

  const money = (cents, currency = 'EGP') => new Intl.NumberFormat('en-EG', { style: 'currency', currency, maximumFractionDigits: 0 }).format(cents / 100);
  const setPanels = (next) => {
    drawer?.classList.toggle('open', next === 'cart');
    drawer?.setAttribute('aria-hidden', String(next !== 'cart'));
    menu?.classList.toggle('open', next === 'menu');
    menu?.setAttribute('aria-hidden', String(next !== 'menu'));
    backdrop?.classList.toggle('open', Boolean(next));
    if (backdrop) backdrop.tabIndex = next ? 0 : -1;
    body.classList.toggle('panel-open', Boolean(next));
  };
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 2200);
  };

  const renderCart = async (open = false) => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    $$('[data-cart-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
    $$('[data-cart-title-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
    const items = $('[data-cart-items]');
    const total = $('[data-cart-total]');
    if (items) {
      items.innerHTML = cart.items.length ? cart.items.map((item, index) => `
        <article class="cart-item" data-cart-line="${index + 1}">
          ${item.image ? `<img src="${item.image}" alt="">` : ''}
          <div><h3>${item.product_title}</h3><p>${item.variant_title || 'Pure linen'} · Qty ${item.quantity}</p><span>${money(item.final_line_price, cart.currency)}</span></div>
          <button type="button" data-cart-remove="${index + 1}" aria-label="Remove ${item.product_title.replace(/"/g, '&quot;')}">×</button>
        </article>`).join('') : '<div class="empty-cart"><p>Your bag is waiting.</p><a href="/collections/women">Explore the collection</a></div>';
    }
    total?.classList.toggle('is-empty', !cart.items.length);
    const subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price, cart.currency);
    if (open) setPanels('cart');
    return cart;
  };

  const addVariant = async (id, quantity = 1) => {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity }] }) });
    if (!response.ok) throw new Error('Unable to add item');
    return response.json();
  };

  document.addEventListener('click', async (event) => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-cart-open]')) { event.preventDefault(); await renderCart(true).catch(() => setPanels('cart')); }
    if (target.matches('[data-cart-close], [data-menu-close], [data-drawer-backdrop]')) { event.preventDefault(); setPanels(null); }
    if (target.matches('[data-menu-open]')) { event.preventDefault(); setPanels('menu'); }
    if (target.matches('[data-quick-add]')) {
      event.preventDefault();
      target.disabled = true;
      try { await addVariant(target.dataset.quickAdd); await renderCart(true); showToast(`${target.dataset.productTitle} added to your bag`); }
      catch { showToast('We could not add that piece. Please try again.'); }
      finally { target.disabled = false; }
    }
    if (target.matches('[data-cart-remove]')) {
      event.preventDefault(); target.disabled = true;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(target.dataset.cartRemove), quantity: 0 }) });
      await renderCart();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    submit.disabled = true;
    try { await addVariant(new FormData(form).get('id')); await renderCart(true); showToast('Added to your bag'); }
    catch { showToast('We could not add that piece. Please try again.'); }
    finally { submit.disabled = false; }
  });

  $$('[data-product-root]').forEach((root) => {
    const select = $('[data-variant-select]', root);
    const fieldsets = $$('[data-option-index]', root);
    fieldsets.forEach((fieldset) => fieldset.addEventListener('click', (event) => {
      const button = event.target.closest('[data-option-value]');
      if (!button) return;
      $$('[data-option-value]', fieldset).forEach((node) => node.classList.toggle('active', node === button));
      const chosen = fieldsets.map((group) => $('[data-option-value].active', group)?.dataset.optionValue);
      const option = [...select.options].find((item) => JSON.parse(item.dataset.options).every((value, index) => value === chosen[index]) && !item.disabled);
      if (option) select.value = option.value;
    }));
  });

  $$('[data-product-switcher]').forEach((root) => {
    $$('[data-product-tab]', root).forEach((tab) => tab.addEventListener('click', () => {
      const group = tab.dataset.productTab;
      $$('[data-product-tab]', root).forEach((item) => { const active = item === tab; item.classList.toggle('active', active); item.setAttribute('aria-selected', String(active)); });
      $$('[data-product-group]', root).forEach((card) => card.classList.toggle('is-hidden', card.dataset.productGroup !== group));
      const link = $('[data-collection-link]', root);
      if (link) link.href = group === 'Women' ? link.dataset.womenUrl : link.dataset.menUrl;
    }));
  });

  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); }), { threshold: 0.14 }) : null;
  $$('[data-reveal]').forEach((item) => revealObserver ? revealObserver.observe(item) : item.classList.add('is-visible'));

  $$('[data-linen-story]').forEach((story) => {
    const images = $$('.linen-story-media img', story); const copies = $$('[data-story-copy]', story); const dots = $$('[data-story-dot]', story); const gradient = $('.linen-story-gradient', story); const current = $('[data-story-current]', story);
    let active = -1; let frame = null;
    const activate = (index) => {
      if (index === active && images[index]?.classList.contains('active')) return;
      active = index; story.classList.toggle('story-tone-dark', index === 0);
      images.forEach((image, i) => { image.classList.toggle('active', i === index); image.setAttribute('aria-hidden', String(i !== index)); image.alt = i === index ? ['Flax flowers growing in warm sunlight','Hand-tied bundles of harvested flax resting on earth','Natural linen cloth folded on a workshop table','Man in natural linen overlooking the sea'][i] : ''; });
      copies.forEach((copy, i) => { copy.classList.toggle('active', i === index); copy.setAttribute('aria-hidden', String(i !== index)); copy.inert = i !== index; });
      dots.forEach((dot, i) => { dot.classList.toggle('active', i === index); if (i === index) dot.setAttribute('aria-current', 'step'); else dot.removeAttribute('aria-current'); });
      gradient.className = `linen-story-gradient gradient-${index + 1}`; current.textContent = `0${index + 1}`;
    };
    const update = () => { frame = null; const rect = story.getBoundingClientRect(); const range = Math.max(1, story.offsetHeight - $('.linen-story-stage', story).offsetHeight); const progress = Math.max(0, Math.min(.9999, -rect.top / range)); activate(Math.min(3, Math.floor(progress * 4))); };
    const requestUpdate = () => { if (frame === null) frame = requestAnimationFrame(update); };
    addEventListener('scroll', requestUpdate, { passive: true }); addEventListener('resize', requestUpdate, { passive: true }); update();
    dots.forEach((dot, index) => dot.addEventListener('click', () => { const top = scrollY + story.getBoundingClientRect().top; const range = Math.max(1, story.offsetHeight - $('.linen-story-stage', story).offsetHeight); scrollTo({ top: top + range * ((index + .08) / 4), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }));
  });

  const onScroll = () => body.classList.toggle('has-scrolled', scrollY > 24);
  onScroll(); addEventListener('scroll', onScroll, { passive: true });
  document.documentElement.classList.remove('no-js');
})();
